import { supabase } from '../supabaseClient';

/* Accès aux données « jira_sync_config ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchJiraSyncConfig() {
  return supabase.from('jira_sync_config').select('issue_key_map').eq('id', 'v1').single();
}

export function saveIssueKeyMap(merged) {
  return supabase
    .from('jira_sync_config')
    .upsert(
      { id: 'v1', issue_key_map: merged, updated_at: new Date().toISOString() },
      { onConflict: 'id' },
    );
}

export function saveJiraSyncConfig(default_brique_map, epic_map, project_keys) {
  return supabase.from('jira_sync_config').upsert(
    {
      id: 'v1',
      project_keys,
      epic_map,
      default_brique_map,
      updated_at: new Date().toISOString(),
    },
    { onConflict: 'id' },
  );
}
